
import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

const valueToTime = (duration = 0, withSeconds = false) => {
  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (duration === 24 || duration === '24') {
    return withSeconds ? '24:00:00' : '24:00'
  }

  if (isInteger) {
    if (withSeconds) {
      return (duration < 10) ? ('0' + duration + ':00:00') : (duration + ':00:00')
    } else {
      return (duration < 10) ? ('0' + duration + ':00') : (duration + ':00')
    }
  } else if (isFloat) {
    if (withSeconds) {
      return moment(duration, 'HHmm').format('HH:mm:ss')
    } else {
      return moment(duration, 'HHmm').format('HH:mm')
    }
  } else if (typeof duration === 'string') {
    if (withSeconds) {
      return moment(duration, 'HH:mm').format('HH:mm:ss')
    } else {
      return moment(duration, 'HH:mm').format('HH:mm')
    }
  } else {
    return duration
  }
}

const valueToDB = (duration = 0) => {
  if (duration === 24 || duration === '24' || duration === '24:00') {
    return 24
  }

  const isNumber = typeof duration === 'number' && !isNaN(duration)
  const isInteger = isNumber && Number.isInteger(duration)
  const isFloat = isNumber && !isInteger

  if (isInteger) {
    return duration
  } else if (isFloat) {
    return moment(duration, 'HHmm').format('HH:mm')
  } else if (typeof duration === 'string') {
    return moment(duration, 'HH:mm').format('HH:mm')
  } else {
    return duration
  }
}

export {
  valueToTime,
  valueToDB,
}
